import { render, staticRenderFns } from "./todayvideo.vue?vue&type=template&id=030b2798&scoped=true&"
import script from "./todayvideo.vue?vue&type=script&lang=js&"
export * from "./todayvideo.vue?vue&type=script&lang=js&"
import style0 from "./todayvideo.vue?vue&type=style&index=0&id=030b2798&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030b2798",
  null
  
)

export default component.exports